const storageKey = (userId: number): string =>
    `voltox-${userId}-warehouse-coming-update-catalog-price`;

const parseStoredBoolean = (raw: string): boolean => {
    try {
        return JSON.parse(raw) === true;
    } catch {
        return raw === '1' || raw === 'true';
    }
};

export const loadUpdateCatalogPrice = (userId: number): boolean => {
    if (!userId || typeof window === 'undefined') return false;
    try {
        const raw = window.localStorage.getItem(storageKey(userId));
        if (raw === null) return false;
        return parseStoredBoolean(raw);
    } catch {
        return false;
    }
};

export const saveUpdateCatalogPrice = (userId: number, value: boolean): void => {
    if (!userId || typeof window === 'undefined') return;
    try {
        window.localStorage.setItem(storageKey(userId), JSON.stringify(Boolean(value)));
    } catch {
        /* ignore quota / private mode */
    }
};
